import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { IQueryParams } from 'queries';
import helpers from 'helpers/index';
import queryClient from 'queries';

export interface TypedUser_tax_information {
  id?: string;
  user_id?: string;
  tax_type?: string;
  name?: string;
  buyer_name?: string;
  tax_code?: string;
  tax_cccd?: string;
  tax_mamoiquanhengansach?: string;
  invoice_email?: string;
  invoice_phone?: string;
  invoice_address?: string;
  // contact_name?: string;
  // contact_email?: string;
  // contact_phone?: string;
  // payment_method?: string;
  // bank_account_name?: string;
  // bank_account_number?: string;
  // bank_name?: string;
  note?: string;
  is_default?: number;
  createdAt?: string;
}

type IQuery = TypedUser_tax_information & IQueryParams;

export function useGetUserTaxInformations(object: IQuery) {
  const EndURL = helpers.buildEndUrl(object);
  return useQuery({
    queryKey: ['user_tax_information/fetch_entity_list', object],
    queryFn: () =>
      axios.get<TypedUser_tax_information[]>(`/user_tax_information${EndURL}`).then((response) => {
        let { data, headers } = response;
        return {
          body: data,
          totalItems: Number(headers['x-total-count'] || 0),
        };
      }),
    retry: 1,
    enabled: !!object.user_id,
  });
}

export function useMutateGetUserTaxInformation() {
  return useMutation({
    mutationKey: ['user_tax_information/fetch_entity'],
    mutationFn: (tax_information_id: string) =>
      axios.get<TypedUser_tax_information>(`/user_tax_information/${tax_information_id}`).then((response) => response.data),
  });
}

export function useMutateCreateUserTaxInformation() {
  return useMutation({
    mutationKey: ['user_tax_information/create_entity'],
    mutationFn: (entity: TypedUser_tax_information) =>
      axios.post<TypedUser_tax_information>(`/user_tax_information`, helpers.cleanEntity(entity)).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user_tax_information/fetch_entity_list'] });
    },
  });
}

export function useUpdateUserTaxInformation() {
  return useMutation({
    mutationKey: ['user_tax_information/update_entity'],
    mutationFn: ({ id, ...rest }: TypedUser_tax_information) =>
      axios.patch<TypedUser_tax_information>(`/user_tax_information/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user_tax_information/fetch_entity_list'] });
      queryClient.invalidateQueries({ queryKey: ['user_tax_information/fetch_entity'] });
    },
  });
}

export function useDeleteUserTaxInformation() {
  return useMutation({
    mutationKey: ['user_tax_information/delete_entity'],
    mutationFn: (tax_information_id: string) => axios.delete<any>(`/user_tax_information/${tax_information_id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user_tax_information/fetch_entity_list'] });
    },
  });
}
